// removed by extract-text-webpack-plugin
module.exports = {"productBox":"qempo_ProductBox_productBox-SnDFJB5","contentWrap":"qempo_ProductBox_contentWrap-1VMb-Q9","content":"qempo_ProductBox_content-3IQtrb5","info1":"qempo_ProductBox_info1-2qvqIB4","name":"qempo_ProductBox_name-2pqEgIs","vl":"qempo_ProductBox_vl-3MtpoqC","info2":"qempo_ProductBox_info2-1NWIgZQ","price":"qempo_ProductBox_price-3jZzw4w","freeOption":"qempo_ProductBox_freeOption-1kglKvo"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/featured-products/components/ProductBox/ProductBox.scss
// module id = 2022
// module chunks = 0